import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { colors } from './colorsPalettes';

export default function Bar({ xLabels, series }) {
  return (
    <BarChart
      height={400}
      margin={{ top: 80 }}
      series={series}
      xAxis={[{ data: xLabels, scaleType: 'band' }]}
      colors={colors}
      grid={{ vertical: false, horizontal: true }}
      barLabel={(item, context) => {
        if ((context.bar.height ?? 0) < 16) {
          return '';
        }
        return item.value;
      }}
      sx={{
        [`& .MuiBarLabel-root `]: {
          fill: 'white',
          fontSize: 14,
        },
      }}
    />
  );
}
